<template>
  <div class="menu" :class="classes">
    <div class="menu__background"></div>
    <div class="menu__container">
      <div class="menu__rmn">
        <a href="http://www.grandpalais.fr/fr/evenement/jardins" target="_blank">
          <img v-show="isTransparent" src="/static/assets/img/logo_rmn.png" alt="Rmn">
          <img v-show="!isTransparent" src="/static/assets/img/logo_rmn_black.png" alt="Rmn">
        </a>
      </div>
        <router-link class="menu__home-link":to="{ name: 'home' }">
          <div class="menu__title">
              <span class="title__big">Secrets</span>
              <span class="title__small">et</span>
              <span class="title__big">Vertus</span>
              <span class="title__small">des</span>
              <span class="title__big">Plantes</span>
          </div>
        </router-link>
      <div class="menu__btns">
        <ui-button :shareInfos="shareInfos()" type="sound" :isTransparent="isTransparent" ></ui-button>
        <ui-button :shareInfos="shareInfos()" type="facebook" :isTransparent="isTransparent"></ui-button>
        <ui-button :shareInfos="shareInfos()" type="twitter" :isTransparent="isTransparent"></ui-button>
        <!-- <div class="menu__btn menu__btn--toggle-sound" v-on:click="toggleSound">
          <img v-show="isTransparent" src="/static/assets/img/btn_sound.png" alt="Activer / Desactiver son">
          <img v-show="!isTransparent" src="/static/assets/img/btn_sound_black.png" alt="Activer / Desactiver son">
        </div>
        <div class="menu__btn menu__btn--fb">
          <img v-show="isTransparent" src="/static/assets/img/btn_facebook.png" alt="Partage Facebook">
          <img v-show="!isTransparent" src="/static/assets/img/btn_facebook_black.png" alt="Partage Facebook">
        </div>
        <div class="menu__btn menu__btn--twitter">
          <img v-show="isTransparent" src="/static/assets/img/btn_twitter.png" alt="Partage Twitter">
          <img v-show="!isTransparent" src="/static/assets/img/btn_twitter_black.png" alt="Partage Twitter">
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import 'styles/components/menu.styl'
import Emitter from 'core/Emitter'
import UiButton from 'components/UI/Button.vue'

export default {
  name: 'menu',
  components: {
    UiButton
  },
  data () {
    return {
      isTransparent: true,
      isHidden: false,
      muted: false
    }
  },
  computed: {
    classes () {
      let c = {}
      c['menu--is-hidden'] = this.isHidden
      c['menu--is-transparent'] = this.isTransparent
      c['menu--is-white'] = (!this.isTransparent) ? 1 : 0
      c['menu--is-single-page'] = this.isSinglePage

      return c
    },

    isSinglePage () {
      return this.$route.name === 'single-plant'
    }
  },
  mounted () {
    this.isTransparent = (this.isSinglePage) ? 0 : 1
    this.addListeners()
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    addListeners () {
      Emitter.on('HIDE_MENU', this.hideMenu)
      Emitter.on('SET_MENU_WHITE', this.setMenuWhite)
      Emitter.on('SET_MENU_TRANSPARENT', this.setMenuTransparent)
      Emitter.on('SCROLL', this.scroll)
    },

    removeListeners () {
      Emitter.removeListener('HIDE_MENU', this.hideMenu)
      Emitter.removeListener('SET_MENU_WHITE', this.setMenuWhite)
      Emitter.removeListener('SET_MENU_TRANSPARENT', this.setMenuTransparent)
      Emitter.removeListener('SCROLL', this.scroll)
    },

    bindAll () {
      ['setMenuWhite', 'setMenuTransparent', 'showMenu', 'hideMenu', 'scroll']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    scroll ({scrollVars}) {
      if (scrollVars.target > scrollVars.last) {
        if (!this.isHidden && !this.isTransparent) {
          if (!this.timeoutHide) {
            this.timeoutHide = setTimeout(() => {
              this.isHidden = true
            }, 1000)
          }
        }
      } else {
        if (this.timeoutHide) {
          window.clearTimeout(this.timeoutHide)
          this.timeoutHide = null
        }
        if (this.isHidden) {
          this.isHidden = false
        }
      }
    },

    setMenuWhite () {
      this.isTransparent = false
      Emitter.emit('MENU_BLACK_BTNS')
    },

    hideMenu () {
      this.isHidden = true

      if (this.timeoutHideMenu) {
        window.clearTimeout(this.timeoutHideMenu)
        this.timeoutHideMenu = null
      }

      this.timeoutHideMenu = setTimeout(() => {
        this.setMenuWhite()
      }, 400)
    },

    showMenu () {
      this.isHidden = false
    },

    setMenuTransparent () {
      this.isTransparent = true
    },

    // toggleSound () {
    //   this.muted = !this.muted
    //   console.log('toggleSound',  !this.muted);
    //   Emitter.emit('SOUND::TOGGLE_SOUND', {muted: !this.muted, sender: 'toggleSound'})
    // },
    shareInfos () {
      return {
        url: window.location.protocol + '//' + window.location.host,
        text: `Découvrez les secrets des plantes avec le Grand Palais ! #ExpoJardins`,
        // hashtags: 'ExpoJardins',
        via: 'GrandPalaisRmn'
      }
    }

  }
}
</script>



/** WEBPACK FOOTER **
 ** Menu.vue?939cd2d2
 **/